import React from "react";
import call from "./call";
import useQuery, { useGetQueryData, useMutateBody } from "./useQuery";
import { useChannelUpdates } from "./ws/useChannelUpdates";

const PATH = "/projects/:projectId(uuid)/quantities/crossFiltersMetrology";
const UPDATES_PATH = "/projects/:projectId(uuid)/quantities/crossFiltersMetrology/updates";

export const useMetrologyCrossFilters = (projectId: string) => {
  const getCachedData = useGetQueryData(PATH, { routeParams: { projectId } });
  const readItems = React.useCallback(() => getCachedData()?.body, [getCachedData]);
  const fetchUpdatedItems = React.useCallback(
    async (since: string) => {
      const { crossFilterQuantities, deletedCrossFilterQuantityIds } = (
        await call("GET", UPDATES_PATH, {
          routeParams: { projectId },
          query: { since: new Date(since) },
        })
      ).body;
      return [crossFilterQuantities, deletedCrossFilterQuantityIds] as const;
    },
    [projectId],
  );

  const mutateItems = useMutateBody(PATH, {
    routeParams: { projectId },
  });

  useChannelUpdates(
    { key: "cross_quantity_invalidity_filters", projectId },
    {
      fetchUpdatedItems,
      mutateItems,
      readItems,
    },
  );

  return useQuery(PATH, { routeParams: { projectId } }).body;
};

export type MetrologyCrossFilters = ReturnType<typeof useMetrologyCrossFilters>;
